'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = ['M0 256C0 292.8 20.7 324.8 51.1 340.9 41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256zm135.7 24.4L170.2 247c7.9 8.2 25.4 26.3 52.5 54.3l106.1-145.8 14.1-19.4 38.8 28.3-14.1 19.4-122.9 168.9-16.8 23.1-19.8-20.6c-43.6-45.1-67.7-70.1-72.4-74.8z', 'M381.7 164.3l-14.1 19.4-122.9 168.9-16.8 23.1-19.8-20.6c-43.6-45.1-67.7-70.1-72.4-74.8L170.2 247c7.9 8.2 25.4 26.3 52.5 54.3l106.1-145.8 14.1-19.4 38.8 28.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;